import { produce } from 'immer';

import {
  CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_REQUEST,
  CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_SUCCESS,
  CONTRACT_SETUP_BY_DRAFT_REQUEST,
  CONTRACT_SETUP_BY_DRAFT_SUCCESS,
  DOCUMENT_SETUP__REQUESTER_FIELDS_PAGE_OVER_DELETE,
  DOCUMENT_SETUP_CLEAR_ALL_STATE,
  DOCUMENT_SETUP_REQUESTER_CHECK_FIELD_DELETE,
  DOCUMENT_SETUP_REQUESTER_CHECK_FIELD_INSERTED,
  DOCUMENT_SETUP_REQUESTER_IMAGE_FIELD_DELETE,
  DOCUMENT_SETUP_REQUESTER_IMAGE_FIELD_INSERTED,
  DOCUMENT_SETUP_REQUESTER_TEXT_FIELD_DELETE,
  DOCUMENT_SETUP_REQUESTER_TEXT_FIELD_INSERTED,
  TEMPLATE_INFORMATION_FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { ContractSetupAction } from '@app/store/contract-setup/actions';
import { DocumentSetupAction } from '@app/store/documentSetup/actions';
import {
  scheduledDocumentPreviewDataFetched,
  setupTemplateByDraft,
  TemplateAction,
} from '@app/store/template/actions';

export interface RequesterInputIdsInPageState {
  [page: number]: Array<string>;
}

const initialState: RequesterInputIdsInPageState = {};

export default function reducer(
  state: RequesterInputIdsInPageState = initialState,
  action: DocumentSetupAction | ContractSetupAction | TemplateAction
): RequesterInputIdsInPageState {
  switch (action.type) {
    case CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_REQUEST:
    case CONTRACT_SETUP_BY_DRAFT_REQUEST:
    case DOCUMENT_SETUP_CLEAR_ALL_STATE:
      return initialState;
    case CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_SUCCESS:
      return produce(state, (draft) => {
        const { requesterFields } = action.payload;
        requesterFields
          .sort((a, b) => a.positionZ - b.positionZ)
          .forEach((field) => {
            const { id, positionPage } = field;
            if (!(positionPage in draft)) {
              draft[positionPage] = [];
            }
            draft[positionPage].push(id);
          });
      });
    case scheduledDocumentPreviewDataFetched.type:
    case TEMPLATE_INFORMATION_FETCH_SUCCESS:
      return produce(state, (draft) => {
        const { requesterInputs } = action.payload;
        requesterInputs
          .sort((a, b) => a.position.z - b.position.z)
          .forEach((field) => {
            const {
              id,
              position: { page },
            } = field;
            if (!(page in draft)) {
              draft[page] = [];
            }
            draft[page].push(id);
          });
      });
    case CONTRACT_SETUP_BY_DRAFT_SUCCESS:
    case setupTemplateByDraft.type:
      return produce(state, (draft) => {
        const { requesterInputs } = action.payload;
        requesterInputs
          .map((requesterInput, index) => ({
            ...requesterInput,
            position: {
              ...requesterInput.position,
              z: requesterInput.position.z ?? index + 1,
            },
          }))
          .sort((a, b) => a.position.z - b.position.z)
          .forEach((field) => {
            const {
              id,
              position: { page },
            } = field;
            if (!(page in draft)) {
              draft[page] = [];
            }
            draft[page].push(id);
          });
      });
    case DOCUMENT_SETUP_REQUESTER_CHECK_FIELD_DELETE:
    case DOCUMENT_SETUP_REQUESTER_IMAGE_FIELD_DELETE:
    case DOCUMENT_SETUP_REQUESTER_TEXT_FIELD_DELETE:
      return produce(state, (draft) => {
        const { id } = action.payload;
        const pages: number[] = Object.keys(draft).map((page) => Number(page));
        pages.forEach((page) => {
          const index = draft[page].findIndex((v) => v === id);
          if (index > -1) {
            draft[page].splice(index, 1);
          }
        });
      });
    case DOCUMENT_SETUP_REQUESTER_CHECK_FIELD_INSERTED:
    case DOCUMENT_SETUP_REQUESTER_IMAGE_FIELD_INSERTED:
    case DOCUMENT_SETUP_REQUESTER_TEXT_FIELD_INSERTED:
      return produce(state, (draft) => {
        const { id, pageNumber } = action.payload;
        if (!(pageNumber in draft)) {
          draft[pageNumber] = [];
        }
        draft[pageNumber].push(id);
      });
    case DOCUMENT_SETUP__REQUESTER_FIELDS_PAGE_OVER_DELETE:
      return produce(state, (draft) => {
        const { maxPage } = action.payload;
        const pages: number[] = Object.keys(draft).map((page) => Number(page));
        pages.forEach((page) => {
          if (page > maxPage) {
            delete draft[page];
          }
        });
      });
    default:
      return state;
  }
}
